import React, { useEffect, useState } from "react";
import ValidationMessage from "../validation-message";
import { inputValidation } from "../../../utility/helpers";

const Input = React.forwardRef(
    (
        {
            overrideClasses,
            value = "",
            validation = true,
            validationType = null,
            formState = null,
            setFormState = null,
            minValue = null,
            maxValue = null,
            minimumLength = null,
            maximumLength = null,
            ...props
        },
        ref
    ) => {
        const [error, setError] = useState(null);

        const defaultClassNames = `text-gray-700 w-full pl-2 pr-2 py-2 border border-gray-200 focus:outline-blue-500 ${
            props?.prefix ? "" : "rounded-l"
        } ${props?.postfix ? "" : "rounded-r"}`;
        const classNames = overrideClasses
            ? overrideClasses
            : defaultClassNames +
              (props?.className ? " " + props?.className : "");

        useEffect(() => {
            if (formState?.[props?.name]?.touched && validation) {
                const message = inputValidation(
                    value,
                    {
                        ...props,
                        minValue,
                        maxValue,
                        minimumLength,
                        maximumLength,
                    },
                    validationType
                );
                setError(message);
                if (setFormState) {
                    const updated = { ...formState };
                    updated[props?.name] ??= {}
                    updated[props?.name].hasError = !!message;
                    updated[props?.name].message = message;
                    setFormState(updated);
                }
            } else {
                if (setFormState) {
                    const updated = { ...formState };
                    updated[props?.name] ??= {}
                    updated[props?.name].hasError = false;
                    updated[props?.name].message = null;
                    setFormState(updated);
                }
            }
        }, [value]);

        return (
            <div className="flex flex-col w-full">
                <div className="flex">
                    {props?.prefix && (
                        <span className="inline-flex items-center px-3 text-sm text-gray-700 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                            {props?.prefix}
                        </span>
                    )}
                    <div className="flex-grow">
                        <input
                            {...props}
                            ref={ref}
                            className={`${classNames} w-full`}
                            onChange={(event) => {
                                if (setFormState) {
                                    const updated = { ...formState };
                                    updated[props?.name].value =
                                        event.target.value;
                                    updated[props?.name].touched = true;
                                    setFormState(updated);
                                }

                                if (props?.onChange) props?.onChange(event);
                            }}
                            value={value || ""}
                        />
                    </div>
                    {props?.postfix && (
                        <span className="inline-flex items-center px-3 text-sm text-gray-700 bg-gray-200 border rounded-s-0 border-gray-300 border-s-0 rounded-e-md">
                            {props?.postfix}
                        </span>
                    )}
                </div>
                {validation &&
                    (error ||
                        (props?.formState?.[props?.name] &&
                            props?.formState?.[props?.name]?.hasError)) && (
                        <ValidationMessage
                            message={
                                error ||
                                props?.formState?.[props?.name]?.message
                            }
                        />
                    )}
            </div>
        );
    }
);

export default Input;
